<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 자재명 -->
          <c-text
            label="LBL0003254"
            name="materialName"
            v-model="searchParam.materialName"
          >
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            codeGroupCd="MATERIAL_KIND_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="materialKindCd"
            label="자재구분"
            v-model="searchParam.materialKindCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
        <!-- 자재목록 -->
        <c-table
          ref="materialTable"
          title="LBL0003256"
          tableId="materialTable"
          :columns="grid.columns"
          :data="grid.data"
          :columnSetting="false"
          :editable="editable"
          @rowClick="rowClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline>
              <c-btn
                v-if="editable"
                label="엑셀업로드"
                icon="upload"
                @btnClicked="excelUploadData"
              />
              <!-- 검색 -->
              <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
        <q-form ref="editForm">
          <!-- 상세 -->
          <c-card title="LBLDETAIL" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline>
                <!-- 추가 -->
                <c-btn
                  label="LBLREG"
                  v-if="editable"
                  icon="add"
                  @btnClicked="addData"
                />
                <!-- 삭제 -->
                <c-btn
                  label="LBLREMOVE"
                  v-if="editable && dataeditable && updateMode"
                  icon="remove"
                  @btnClicked="deleteData"
                />
                <!-- 저장 -->
                <c-btn
                  v-if="editable && saveable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="data"
                  :mappingType="saveType"
                  label="LBLSAVE"
                  icon="save"
                  @beforeAction="saveMaterial"
                  @btnCallback="saveCallback"
                />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-12">
                <!-- 자재관리번호 -->
                <c-text
                  :editable="editable && dataeditable"
                  :disabled="true"
                  label="자재코드"
                  name="materialCd"
                  v-model="data.materialCd"
                >
                </c-text>
              </div>
              <div class="col-12">
                <!-- 자재명 -->
                <c-text
                  :required="true"
                  :editable="editable && dataeditable"
                  label="LBL0003254"
                  name="materialName"
                  v-model="data.materialName"
                >
                </c-text>
              </div>
              <div class="col-12">
                <c-material-type
                  :editable="editable && dataeditable"
                  type="edit"
                  label="자재분류"
                  name="materialTypeCd"
                  v-model="data.materialTypeCd"
                />
              </div>
            </template>
          </c-card>
        </q-form>
      </div>
      <c-dialog :param="popupOptions"></c-dialog>
    </div>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
import transactionConfig from "@/js/transactionConfig";
export default {
  name: "material-manage",
  data() {
    return {
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        width: "40%",
        param: {},
        closeCallback: null,
      },
      grid: {
        columns: [
          {
            name: "materialCd",
            field: "materialCd",
            label: "자재코드",
            style: "width:120px",
            align: "center",
            sortable: true,
          },
          {
            name: "materialTypeName",
            field: "materialTypeName",
            label: "자재 분류",
            style: "width:140px",
            align: "center",
            sortable: true,
          },
          {
            name: "materialName",
            field: "materialName",
            // 자재명
            label: "LBL0003254",
            align: "left",
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        useFlag: "Y",
        materialCd: "",
        materialName: "",
        chemMaterialFlag: null,
        materialTypeCd: "",
        materialKindCd: null,
      },
      useFlagItems: [
        { code: "Y", codeName: "사용" },
        { code: "N", codeName: "미사용" },
      ],
      data: {
        materialCd: "", // 자재코드
        materialNo: "", // 자재관리번호
        materialName: "", // 자재명(KOR)
        materialNameEn: "", // 자재명(ENG)
        chemMaterialFlag: "", // 화학자재 여부
        materialGroupCd: "", // 자재그룹 코드
        materialGroupName: "", // 자재그룹 명
        materialTypeCd: null, // 자재분류코드
        useFlag: "Y", // 사용여부
      },
      editable: true,
      listUrl: "",
      detailUrl: "",
      checkUrl: "",
      insertUrl: "",
      updateUrl: "",
      deleteUrl: "",
      saveable: false,
      deleteable: false,
      dataeditable: false,
      updateMode: false,
      isSave: false,
      saveUrl: transactionConfig.mdm.user.insert.url,
      saveType: "POST",
      searchUrl: "",
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.dataeditable = false;
      // api scope
      this.saveUrl = transactionConfig.mdm.user.insert.url;
      this.listUrl = selectConfig.mdm.mam.material.list.url;
      this.detailUrl = selectConfig.mdm.mam.material.get.url;
      this.checkUrl = selectConfig.mdm.mam.material.check.url;
      this.insertUrl = transactionConfig.mdm.mam.material.insert.url;
      this.updateUrl = transactionConfig.mdm.mam.material.update.url;
      this.deleteUrl = transactionConfig.mdm.mam.material.delete.url;
      this.getList();
    },
    rowRemoveSelect() {
      var _table = document.getElementsByClassName("bg-light-blue-1")[0];
      if (_table) {
        _table.classList.remove("bg-light-blue-1");
      }
    },
    getList() {
      this.reset();
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
      this.saveable = false;
      this.deleteable = false;
    },
    rowClick(row) {
      // 상세조회
      this.saveable = true;
      this.deleteable = true;
      this.rowNotSelected = false;
      this.updateMode = true;
      this.$http.url = this.$format(this.detailUrl, row.materialCd);
      this.$http.type = "GET";
      this.$http.request(
        (_result) => {
          this.data = _result.data;
          this.saveUrl = this.updateUrl;
          this.saveType = "PUT";
          this.dataeditable = true;
        },
        () => {}
      );
    },
    addData() {
      this.saveable = true;
      this.deleteable = false;
      this.saveUrl = this.insertUrl;
      this.saveType = "POST";
      this.updateMode = false;
      this.dataeditable = true;
      this.data = {
        materialCd: "", // 자재코드
        materialNo: "", // 자재관리번호
        materialName: "", // 자재명(KOR)
        materialNameEn: "", // 자재명(ENG)
        chemMaterialFlag: "", // 화학자재 여부
        materialGroupCd: "", // 자재그룹 코드
        materialGroupName: "", // 자재그룹 명
        materialTypeCd: null, // 자재분류코드
        useFlag: "Y", // 사용여부
      };
    },
    reset() {
      this.rowRemoveSelect();
      this.saveable = false;
      this.deleteable = false;
      this.updateMode = false;
      this.dataeditable = false;
      this.data = {
        materialCd: "", // 자재코드
        materialNo: "", // 자재관리번호
        materialName: "", // 자재명(KOR)
        materialNameEn: "", // 자재명(ENG)
        chemMaterialFlag: "", // 화학자재 여부
        materialGroupCd: "", // 자재그룹 코드
        materialGroupName: "", // 자재그룹 명
        materialTypeCd: null, // 자재분류코드
        useFlag: "Y", // 사용여부
      };
    },
    saveMaterial() {
      this.$refs["editForm"].validate().then((_result) => {
        if (_result) {
          this.$http.url = this.$format(this.checkUrl, this.data.materialCd);
          this.$http.type = "GET";
          this.$http.request((_result) => {
            if (this.updateMode || _result.data === 0) {
              window.getApp.$emit("CONFIRM", {
                title: "LBLCONFIRM",
                message: "MSGSAVE", // 저장하시겠습니까?
                // TODO : 필요시 추가하세요.
                type: "info", // success / info / warning / error
                // 확인 callback 함수
                confirmCallback: () => {
                  this.data.regUserId = this.$store.getters.user.userId;
                  this.data.chgUserId = this.$store.getters.user.userId;
                  this.isSave = !this.isSave;
                },
                // 취소 callback 함수
                cancelCallback: () => {},
              });
            } else {
              window.getApp.$emit("ALERT", {
                title: "LBLGUIDE", // 안내
                message: "동일한 자재코드가 존재합니다.", // 동일한 자재코드가 존재합니다.
                type: "warning", // success / info / warning / error
              });
              return;
            }
          });
        }
      });
    },
    deleteData() {
      window.getApp.$emit("CONFIRM", {
        title: "LBLCONFIRM",
        message: "MSGREMOVE", // 삭제하시겠습니까?,
        // TODO : 필요시 추가하세요.
        type: "warning", // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.data.materialCd);
          this.$http.type = "DELETE";
          this.$http.request(() => {
            window.getApp.$emit("APP_REQUEST_SUCCESS");
            this.getList();
          });
        },
        // 취소 callback 함수
        cancelCallback: () => {},
      });
    },
    saveCallback() {
      window.getApp.$emit("APP_REQUEST_SUCCESS");
      this.getList();
    },
    excelUploadData() {
      this.popupOptions.title = "자재마스터 업로드";
      this.popupOptions.target = () =>
        import(`${"./materialManageExcelUpload.vue"}`);
      this.popupOptions.isFull = true;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeExcelUploadPopup;
    },
    closeExcelUploadPopup(_result) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (_result && _result.length > 0) {
        let s_data = this.$_.filter(_result, (item) => {
          return !item.error_message;
        });
        this.$_.forEach(s_data, (item) => {
          item.SysRevision = 1;
          item.regUserId = this.$store.getters.user.userId; // 등록자 ID
          item.chgUserId = this.$store.getters.user.userId; // 수정자 ID
        });

        this.$http.url =
          transactionConfig.mdm.mam.material.insert.url + "/excel";
        this.$http.type = "POST";
        this.$http.param = s_data;
        this.$http.request(() => {
          window.getApp.$emit("APP_REQUEST_SUCCESS");
          this.getList();
        });
      }
    },
  },
};
</script>
